import { MainPropertyType } from '@aloft/toolkit-shared';

export function extractPropertyType(
  sale: Element,
  defaultPropertyType: MainPropertyType,
): MainPropertyType {
  try {
    const manufacturedHomeIndicator = sale.getAttribute('ManufacturedHomeIndicator') ?? undefined;

    if (manufacturedHomeIndicator === 'Y') {
      return 'manufacturedHome';
    }

    if (defaultPropertyType === 'manufacturedHome' && manufacturedHomeIndicator === 'N') {
      return 'singleFamilyResidence';
    }

    return defaultPropertyType;
  } catch (e: unknown) {
    console.warn('Failed to parse property type, using default', e);
    return defaultPropertyType;
  }
}
